import { Show, createSignal } from "solid-js";
import type { Component, JSX } from "solid-js";

export const CollapsibleSection: Component<{
  title: string;
  children: JSX.Element;
  defaultOpen?: boolean;
}> = (props) => {
  const [isOpen, setIsOpen] = createSignal(props.defaultOpen ?? true);

  return (
    <section class="profile-section">
      <button
        type="button"
        class="profile-section__header"
        onClick={() => setIsOpen(!isOpen())}
        aria-expanded={isOpen()}
      >
        <h3 class="profile-section__title">{props.title}</h3>
        <i class={`fa-solid ${isOpen() ? "fa-chevron-up" : "fa-chevron-down"} profile-section__chevron`}></i>
      </button>
      <Show when={isOpen()}>
        <div class="profile-section__content">{props.children}</div>
      </Show>
    </section>
  );
};
